<template>
<nav class="nav_center2" style="padding: 0; background: cadetblue">
    <ul class="ul_menu" style="list-style: none; color: white;">
        <li :class="{ topmenuactive: activeTab === 'taitroxa' }" @click="changeTab('taitroxa')">
            <a id="urlTaitroxa">Tài trợ xã
            </a>
        </li>
        <li :class="{ topmenuactive: activeTab === 'Taitrotruonghoc' }" @click="changeTab('Taitrotruonghoc')">
            <a id="urlBai1" href="vi/chuongtrinhtaitroxathidiem#thoathuantaitro/taitrotruonghoc">Tài trợ trường học </a>
        </li>
        <li :class="{ topmenuactive: activeTab === 'Taitrotruongchuyen' }" @click="changeTab('Taitrotruongchuyen')">
            <a id="urlBai2" href="vi/chuongtrinhtaitroxathidiem#thoathuantaitro/taitrotruongchuyen"> Tài trợ trường chuyên</a>
        </li>
        <li :class="{ topmenuactive: activeTab === 'Thoathuanhoptac' }" @click="changeTab('Thoathuanhoptac')">
            <a id="urlBai3"  href="vi/chuongtrinhtaitroxathidiem#thoathuantaitro/thoathuanhoptac">Thỏa thuận hợp tác</a>
        </li>

        <li :class="{ topmenuactive: activeTab === 'lienhe' }" @click="changeTab('lienhe')" style="display: none;">
            <a id="urlBai4">{{
             currentLanguage.header_text_lienHe
           }}</a>
        </li>
    </ul>
</nav>

<div class="wrapper row3">
    <main class="hoc container-fluid clear bv">

        <!-- gioi thieu -->
        <div id="taitroxa" v-show="showTaitroxa" style="min-height: 500px" class="padding-top15">
            <div class="title-bai-viet" v-html="titleTaitroxa"></div>
            <div v-html="contentTaitroxa"></div>
        </div>
        <!-- tieu hoc-->
        <div id="Taitrotruonghoc" v-show="showTaitrotruonghoc" style="min-height: 500px; background-image: none !important" class="padding-top15">
            <div class="title-bai-viet" v-html="titleTaitrotruonghoc"></div>
            <div v-html="contentTaitrotruonghoc"></div>
        </div>
        <!-- Taitrotruongchuyen -->
        <div id="Taitrotruongchuyen" v-show="showTaitrotruongchuyen" style="min-height: 500px; background-image: none !important" class="padding-top15">
            <div class="title-bai-viet" v-html="titleTaitrotruongchuyen"></div>
            <div v-html="contentTaitrotruongchuyen"></div>
        </div>
        <!-- Thoathuanhoptac -->
        <div id="Thoathuanhoptac" v-show="showThoathuanhoptac" style="min-height: 500px; background-image: none !important" class="padding-top15">
            <div class="title-bai-viet" v-html="titleThoathuanhoptac"></div>
            <div v-html="contentThoathuanhoptac"></div>
        </div>

        <!-- LIEN HE -->
        <div id="lienhe" v-show="showLienHe" style="min-height: 500px; background-image: none !important">
            <div class="title-bai-viet" v-html="titleLienHe"></div>
            <div v-html="contentLienHe"></div>
        </div>

    </main>
</div>
</template>

<script>
import {
    languages
} from "@/components/languages";
import {
    apiChiTietBaiViet
} from "@/components/listService";
import axios from "axios";
// import { vmCrop } from "@/components/axiosVM";

export default {
    components: {},
    data() {
        return {
            activeTab: "taitroxa",
            isMenuVisible: false,
            currentLanguage: languages.vi,
            lang: "",
            base64: "",
            base64Title: "",

            //show
            showTaitroxa: true,
            showTaitrotruonghoc: false,
            showTaitrotruongchuyen: false,
            showThoathuanhoptac: false,
            showLienHe: false,

            //active tab
            isActiveTaitroxa: true,
            isActiveTaitrotruonghoc: false,
            isActiveTaitrotruongchuyen: false,
            isAcitveThoathuanhoptac: false,
            isActiveLienHe: false,

            //title
            titleTaitroxa: "",
            titleTaitrotruonghoc: "",
            titleTaitrotruongchuyen: "",
            titleThoathuanhoptac: "",
            titleLienHe: "",

            //content
            contentTaitroxa: "",
            contentTaitrotruonghoc: "",
            contentTaitrotruongchuyen: "",
            contentThoathuanhoptac: "",
            contentLienHe: "",

            hasMounted: false,
        };
    },
    mounted() {
        if (window.innerWidth <= 768) {
            this.isMenuVisible = false;
        } else {
            this.isMenuVisible = true;
        }
        // this.performPostRequest("1755239811442fQJ18", "taitroxa", this.lang);
        if (!this.hasMounted) {
            this.hasMounted = true;
            this.lang = localStorage.getItem("languages") || "vi";
            // this.performPostRequest("1755075075179y5bWE", "Xavangiang", this.lang);
            document.getElementById("urlTaitroxa").setAttribute("href", this.lang + "/chuongtrinhtaitroxathidiem#thoathuantaitro/taitroxa");
            document.getElementById("urlBai1").setAttribute("href", this.lang + "/chuongtrinhtaitroxathidiem#thoathuantaitro/taitrotruonghoc");
            document.getElementById("urlBai2").setAttribute("href", this.lang + "/chuongtrinhtaitroxathidiem#thoathuantaitro/taitrotruongchuyen");
            document.getElementById("urlBai3").setAttribute("href", this.lang + "/chuongtrinhtaitroxathidiem#thoathuantaitro/thoathuanhoptac");

            let fragmentTab = window.location.hash.substring(1);
            if (fragmentTab.endsWith("/")) {
                fragmentTab = fragmentTab.slice(0, -1);
            }
            console.log("fragmentTab " + fragmentTab);

            if (fragmentTab === "thoathuantaitro/taitroxa") {
                this.changeTab("taitroxa");
            } else if (fragmentTab === "thoathuantaitro/taitrotruonghoc") {
                this.changeTab("Taitrotruonghoc");
            } else if (fragmentTab === "thoathuantaitro/taitrotruongchuyen") {
                this.changeTab("Taitrotruongchuyen");
            } else if (fragmentTab === "thoathuantaitro/thoathuanhoptac") {
                this.changeTab("Thoathuanhoptac");
            } else {
                // Nếu không phù hợp với bất kỳ tab nào, mặc định hiển thị tab gioiThieu
                this.changeTab("taitroxa");
            }
        }
    },
    created() {
        const savedLanguage = localStorage.getItem("languages") || "vi";
        if (savedLanguage && languages[savedLanguage]) {
            this.currentLanguage = languages[savedLanguage];
        }
    },
    methods: {
        changeLanguage(lang) {
            this.currentLanguage = languages[lang];
            localStorage.setItem("languages", lang);
            window.location.reload();
        },

        async performPostRequest(id, section) {
            this.lang = localStorage.getItem("languages") || "vi";

            try {
                // Thực hiện POST request
                const response = await axios.post(
                    apiChiTietBaiViet, {
                        id: id,
                        langId: "0",
                    },
                );
                const data = response.data.result;
                this.base64 = data[`content_${this.lang}`];
                this.base64Title = data[`title_${this.lang}`];

                var title = atob(this.base64Title);
                var decodedString = atob(this.base64);

                // Store content separately for each section
                if (section === "taitroxa") {
                    this.titleTaitroxa = decodeURIComponent(escape(title));
                    this.contentTaitroxa = decodeURIComponent(escape(decodedString));
                } else if (section === "Taitrotruonghoc") {
                    this.titleTaitrotruonghoc = decodeURIComponent(escape(title));
                    this.contentTaitrotruonghoc = decodeURIComponent(escape(decodedString));
                } else if (section === "Taitrotruongchuyen") {
                    this.titleTaitrotruongchuyen = decodeURIComponent(escape(title));
                    this.contentTaitrotruongchuyen = decodeURIComponent(escape(decodedString));
                } else if (section === "Thoathuanhoptac") {
                    this.titleThoathuanhoptac = decodeURIComponent(escape(title));
                    this.contentThoathuanhoptac = decodeURIComponent(escape(decodedString));
                } else if (section === "lienhe") {
                    this.titleLienHe = decodeURIComponent(escape(title));
                    this.contentLienHe = decodeURIComponent(escape(decodedString));
                }
            } catch (error) {
                console.error("Error:", error);
            }
        },
        toggleMenu() {
            this.isMenuVisible = !this.isMenuVisible;
        },
        changeTab(tab) {
            this.lang = localStorage.getItem("languages") || "vi";
            if (window.innerWidth <= 768) {
                this.isMenuVisible = false;
            }
            // Tạo một đối tượng để lưu trạng thái của các tab
            const tabStates = {
                taitroxa: false,
                Taitrotruonghoc: false,
                Taitrotruongchuyen: false,
                Thoathuanhoptac: false,
                lienhe: false,
            };

            // Thiết lập trạng thái cho tab được chọn
            tabStates[tab] = true;

            // Gọi hàm performPostRequest với các tham số tương ứng
            this.performPostRequest(this.getPostId(tab), tab, this.lang);

            // Cập nhật giá trị activeTab
            this.activeTab = tab;

            // Cập nhật các biến show dựa trên trạng thái của các tab
            this.showTaitroxa = tabStates.taitroxa;
            this.showTaitrotruonghoc = tabStates.Taitrotruonghoc;
            this.showTaitrotruongchuyen = tabStates.Taitrotruongchuyen;
            this.showThoathuanhoptac = tabStates.Thoathuanhoptac;
            this.showLienHe = tabStates.lienhe;
        },

        getPostId(tab) {
            // Sử dụng một đối tượng để ánh xạ tab với id của bài viết tương ứng
            const postIdMap = {
                taitroxa: "1755239811442fQJ18",
                Taitrotruonghoc: "17586169060797IhK0",
                Taitrotruongchuyen: "1758617515678YOeov",
                Thoathuanhoptac: "1758617870665JCZBq",
                lienhe: "1690272053288yg3c7",
            };

            return postIdMap[tab];
        },
    },
};
</script>
